import * as React from 'react';
import { handlerRedirectNewPage } from '@/presentation/modules/home/HomeViewController';
import ArrowRight from '../../../../../../../../assets/icons/ArrowRight.svg';
import { Footer, Question, TextFooter, ArrowFooter } from './bseStyle';

const BSEFooter = () => (
  <Footer>
    <Question>Pasos a seguir:</Question>
    <div className="PL">
      <ol>
        <TextFooter>
          Registra tu expediente completando tu información de acuerdo a tu
          caso.
        </TextFooter>
        <ArrowFooter
          type="button"
          data-testid="cmp-list-documents-button"
          onClick={(e) => {
            handlerRedirectNewPage(
              'https://view.genially.com/6852e23a21fdfa79439b2f66/interactive-content-requisitos-bse',
              e
            );
            (e.target as any).parentElement.blur();
          }}
        >
          <p className="MRA MR">Ver lista de documentos</p>
          <img src={ArrowRight} alt="ArrowRight" />
        </ArrowFooter>
        <TextFooter>
          Realiza el pago a través de los medios financieros autorizados.
        </TextFooter>
        <TextFooter>
          Recibe la conformidad u observaciones a tu correo una vez finalizado
          el trámite.
        </TextFooter>
      </ol>
    </div>
  </Footer>
);

export default BSEFooter;
